<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-button type="primary" size="mini" v-if="!lo" class="float-right borcmodalbuton" @click="Borclandir">
      Borçlandırmayı Onayla
    </el-button>
    <div class="clearfix"></div>
    <hr>
    <el-row :gutter="24">
      <el-col :span="4">
        <mWidget
          :data="{isim: 'Borçlanma Tarihi', sayi: Bilgi.tTarihi, icon: 'el-icon-date', renk: 'ins1 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="4">
        <mWidget
          :data="{isim: 'Son Ödeme Tarihi', sayi: Bilgi.sTarihi, icon: 'el-icon-date', renk: 'ins3 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="4">
        <mWidget
          :data="{isim: 'Kategori', sayi: Bilgi.Kategori, icon: 'el-icon-s-claim', renk: 'ins5 m-widget-mini'}"></mWidget>
      </el-col>
    </el-row>
    <table class="mt-4 table table-xs table-hover">
      <thead>
      <tr>
        <th width="200">Borçlu Adı Soyadı</th>
        <th width="100">Mesken Bilgi</th>
        <th width="40">M2</th>
        <th width="60">Tutar</th>
        <th width="40">Zam Oran</th>
        <th width="300">Açıklama</th>
      </tr>
      </thead>
      <tbody v-for="Onay in data">
      <tr :class="Onay.TableClass">
        <td>{{Onay.Mesken.Oturan.AdSoyad}}</td>
        <td>{{Onay.Mesken.DaireBilgi}}</td>
        <td>{{Onay.Mesken.m2}}</td>
        <td v-if="!Onay.Muaf">
          <input v-model="Onay.Mesken.Borclar[0].Tutar" class="form-control">
          <ol v-if="Onay.Mesken.Indirim.Detay" class="IndirimList">
            <p>{{Onay.Mesken.Indirim.Oran}}% İndirim Uygulandı</p>
            <li v-for="Detay in Onay.Mesken.Indirim.Detay"><span>{{Detay.Tanim}}</span> {{Detay.Oran}} %</li>
          </ol>
        </td>
        <td v-if="!Onay.Muaf"><input v-model="Onay.Mesken.Borclar[0].zOran" class="form-control"></td>
        <td v-if="!Onay.Muaf">
          <input v-model="Onay.Mesken.Borclar[0].Aciklama" class="form-control">
          <div v-if="Onay.Mesken.Borclar[0].Sms">
            <hr class="mb-0">
            <label>Sms İçerik</label>
            <el-input v-model="Onay.Mesken.Borclar[0].Sms" resize="none" type="textarea"></el-input>
          </div>
        </td>
        <td colspan="3" v-if="Onay.Muaf"></td>
      </tr>

      </tbody>
    </table>
    <div class="clearfix"></div>
  </div>
</template>

<script>
  import MWidget from "../../Genel/mWidget";
  import Yukleniyor from "../../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor, MWidget},
    props: ['data', 'Bilgi'],
    data() {
      return {
        lo: false
      }
    },
    methods: {
      Borclandir() {
        this.lo = true;
        this.$store.dispatch("Post", {...this.data, path: 'muhasebe/tahakkuk/tahakkuk/onayla'})
          .then(response => {
            if (response.Durum == "OK") {
              this.$emit("Onay", true);
              this.$message.success(response.Mesaj);
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.lo = false;
            }
          })

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Muhasebe/tahakkuk/Borclandirma.vue